
import { useNavigate } from "react-router-dom";

import styles from "../..//Styles/Authentication/Login.module.css"

const BtnBack = ({text}) => {
    const navigate = useNavigate();

    return (
        <button className={styles.formLoginBtn} onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.5002 11C25.5002 11.3978 25.3422 11.7794 25.0609 12.0607C24.7796 12.342 24.398 12.5 24.0002 12.5H5.62521L12.0652 18.9388C12.347 19.2206 12.5053 19.6027 12.5053 20.0013C12.5053 20.3998 12.347 20.782 12.0652 21.0638C11.7834 21.3456 11.4012 21.5039 11.0027 21.5039C10.6042 21.5039 10.222 21.3456 9.94021 21.0638L0.940206 12.0638C0.800366 11.9244 0.689411 11.7588 0.613703 11.5765C0.537995 11.3942 0.499023 11.1987 0.499023 11.0013C0.499023 10.8038 0.537995 10.6084 0.613703 10.426C0.689411 10.2437 0.800366 10.0781 0.940206 9.93876L9.94021 0.938759C10.0797 0.799229 10.2454 0.688548 10.4277 0.613036C10.61 0.537523 10.8054 0.498657 11.0027 0.498657C11.2 0.498657 11.3954 0.537523 11.5777 0.613036C11.76 0.688548 11.9257 0.799229 12.0652 0.938759C12.2047 1.07829 12.3154 1.24393 12.3909 1.42624C12.4664 1.60854 12.5053 1.80393 12.5053 2.00126C12.5053 2.19858 12.4664 2.39398 12.3909 2.57628C12.3154 2.75858 12.2047 2.92423 12.0652 3.06376L5.62521 9.50001H24.0002C24.398 9.50001 24.7796 9.65804 25.0609 9.93935C25.3422 10.2207 25.5002 10.6022 25.5002 11Z" fill="black" />
            </svg>

            {text}
        </button>
    );
}

export default BtnBack;